import { Injectable, inject } from '@angular/core';
import { PaymentDetails } from '@boels/models';
import { Observable } from 'rxjs';
import { CheckoutPaymentGatewayService } from '../gateway/checkout-payment.gateway';

@Injectable({
  providedIn: 'any',
})
export class CheckoutPaymentFacade {
  protected checkoutPaymentService = inject(CheckoutPaymentGatewayService);

  setPaymentDetails(
    paymentDetails: PaymentDetails,
  ): Observable<PaymentDetails> {
    return this.checkoutPaymentService.setPaymentDetails(paymentDetails);
  }

  setPaymentInfo(paymentDetails: PaymentDetails): Observable<PaymentDetails> {
    return this.checkoutPaymentService.setPaymentInfo(paymentDetails);
  }
}
